import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IReconcileSocialPostsV1Request } from './reconcile-social-posts-v1-request';
import type { IReconcileSocialPostsV1Response } from './reconcile-social-posts-v1-response';
import { reconcileSocialPostsV1ResponseSchema } from './reconcile-social-posts-v1-response';

export async function reconcileSocialPostsV1Api(
  body: IReconcileSocialPostsV1Request,
): Promise<IValidatedResponse<IReconcileSocialPostsV1Response>> {
  return postRequest<IReconcileSocialPostsV1Response>({
    path: '/sys/social/v1/posts/reconcile',
    body,
    schema: reconcileSocialPostsV1ResponseSchema,
  });
}
